var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6548 5.97477C13.6548 8.00934 12.0052 9.65787 9.97167 9.65787C7.9371 9.65787 6.28748 8.00934 6.28748 5.97477C6.28748 3.94019 7.9371 2.29166 9.97167 2.29166C12.0052 2.29166 13.6548 3.94019 13.6548 5.97477Z",
    stroke: "#525355",
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99993 12.3491C12.7136 12.3421 15.0209 13.5881 15.869 16.2702C14.1595 17.3123 12.1473 17.7137 9.99993 17.7084C7.85253 17.7137 5.84033 17.3123 4.13086 16.2702C4.97995 13.5852 7.28338 12.3421 9.99993 12.3491Z",
    stroke: "#525355",
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.687c2614e5860c5990ab56ac9c9f9a52.svg";
export { ForwardRef as ReactComponent };